<h1 mat-dialog-title fxLayout="column" fxLayoutAlign="center center">Session Timeout</h1>
<div fxLayout="column" fxLayoutAlign="center center">
  <div><mat-icon>alarm</mat-icon></div>
  <div>Your session is about to expire.</div>
  <div><b>{{ leftTime | date:'mm:ss' }}</b></div>
</div>
<div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="center">
  <button mat-raised-button class="theme-button" aria-label="Close" (click)="onNoClick()">Reset</button>
</div>
